export default {
  documento: {
    relationships: {
      entity: {},
      author: {},
    },
  },
};
